import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'rb-ranney-well',
  imports: [RouterOutlet],
  templateUrl: './ranney-well.component.html',
  styleUrl: './ranney-well.component.scss',
})
export class RanneyWellComponent {}
